"use client";

import { useEffect } from "react";

export default function ClerkServiceWorkerRegistration() {
  useEffect(() => {
    if ("serviceWorker" in navigator) {
      // Register the service worker
      navigator.serviceWorker
        .register("/clerk-sw.js")
        .then((registration) => {
          console.log(
            "✅ [ClerkSW] Service Worker registered successfully:",
            registration.scope
          );

          // Listen for updates
          registration.addEventListener("updatefound", () => {
            console.log("🔄 [ClerkSW] New service worker version found");
          });
        })
        .catch((error) => {
          console.warn(
            "⚠️ [ClerkSW] Service Worker registration failed:",
            error
          );
        });

      // Listen for messages from the service worker
      navigator.serviceWorker.addEventListener("message", (event) => {
        if (event.data && event.data.type === "CLERK_CHUNK_ERROR") {
          console.warn(
            "🚨 [ClerkSW] Chunk loading error reported by service worker"
          );
          // Could trigger a reload or show user notification
        }
      });

      // Function to clear Clerk cache when needed
      (
        window as typeof window & { clearClerkCache?: () => void }
      ).clearClerkCache = () => {
        if (navigator.serviceWorker.controller) {
          navigator.serviceWorker.controller.postMessage({
            type: "CLEAR_CLERK_CACHE",
          });
        }
      };
    }
  }, []);

  return null;
}
